<template lang="html">
  <div
    class="user-info"
    :class="{ active: user.uid === userId }"
    v-if="user"
    @click="userDetail(user)"
  >
    <div class="img-warp" :style="{ backgroundImage: `url(${headImg})` }">
      <p
        class="userTypeName"
        :class="{
          isDZ: user.userType === 4,
          isRZ: user.source === 'pop',
          isZJ: user.userType === 3
        }"
      >
        {{ user.userTypeName }}
      </p>
    </div>
    <div class="user-summary">
      <div class="name">
        <p>{{ user.workerName }}</p>
        <!-- <div class="star-level">
                <star :score="user.score" size="medium" :scoreNo="user.starLevel" color="#ffc600"  :levelName="user.starLevelName"></star>
            </div> -->
      </div>
      <p class="address">
        <span v-if="user.age">{{ user.age }}岁</span
        ><span v-if="user.age">|</span
        ><span>{{
          user.place || user.cityName || params.cityname || '江苏省南京市'
        }}</span>
      </p>
      <p
        class="service"
        v-if="user.workCategorys && user.workCategorys.length > 0"
      >
        擅长：{{ serviceDisplay }}
      </p>
      <p class="service" v-else>{{ user.defaultOpenAttr }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  props: {
    // 是否显示箭头
    showArrow: {
      type: Boolean,
      default: true
    },
    // 是否显示地址
    showAddress: {
      type: Boolean,
      default: true
    },
    // 是否可服务
    canServe: {
      type: Boolean,
      default: true
    },
    // 用户信息
    user: {
      type: Object,
      default: () => {}
    },
    // 已选中用户的id
    userId: {
      type: [Number, String],
      default: -1
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      default_pic: require('../../assets/images/default_headerimg.png')
    }
  },
  computed: {
    ...mapState(['serviceTypeList']),
    headImg() {
      return this.$$viewImageInCenter(
        this.user.headImage || this.default_pic,
        120,
        120
      )
    },
    serviceDisplay() {
      const attr = this.user.workCategorys
      if (attr) {
        const attr_names = attr.map(ele => ele.categoryName)
        return attr_names.join('、') || this.user.defaultOpenAttr
      }
      return '孩子王期待为您提供更多更好的专业育儿服务'
    }
  },
  methods: {
    userDetail(user) {
      this.$$tracker('121011911', '20000', '200002')
      if (user.userType === 3) {
        if (this.$$isCZJApp()) {
          // 在成长加李暂时不给跳转育儿专家
          return
          // this.$$cookie.set('_business_tag', '_hzw_', { domain: 'life.cekid.com' })
        }
        location.href = `//shequ.cekid.com/bbs/user/${user.uid}?cmd=usercard&userid=${user.uid}`
      } else {
        location.href = `/v/user/${user.uid}`
      }
    },
    score(score) {
      if (score === '' || score === '0') {
        return 0
      } else {
        return Math.ceil(score / 2)
      }
    },
    gotoUserDetail(user) {
      if (user.uid) {
        this.$$tracker('110101', '20000', 21043, user.workerCode)
        location.href = `/v/user/${user.uid}`
      }
    }
  },
  components: {
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.user-info {
  height: rem(182px);
  @include border(bottom);
  display: flex;
  align-items: center;

  .img-warp {
    // position: relative;
    width: rem(120px);
    height: rem(120px);
    border-radius: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 100%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      position: absolute;
    }

    .userTypeName {
      // position: absolute;
      // left:0;
      // bottom:0;
      width: 100%;
      height: rem(40px);
      margin-top: rem(80px);
      padding-top: rem(6px);
      background-color: rgba(255, 57, 126, 0.8);
      color: #fff;
      text-align: center;
      font-size: rem(18px);

      &.isZJ {
        background-color: rgba(218, 52, 238, 0.8);
      }
      &.isDZ {
        background-color: rgba(255, 182, 55, 0.8);
      }
      &.isRZ {
        background-color: rgba(43, 141, 241, 0.8);
      }
    }
  }

  .user-summary {
    max-width: rem(560px);
    flex: 1;
    font-size: rem(28px);
    padding-left: rem(20px);
    // line-height: 1.3;

    .star-level {
      padding-left: rem(10px);
    }
    .address {
      color: #999;
      font-size: rem(22px);
      margin-top: rem(15px);

      span {
        padding-left: rem(5px);
        padding-right: rem(5px);
      }
    }
    .service {
      margin-top: rem(10px);
      color: #999;
      font-size: rem(22px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .name {
      padding-top: rem(20px);
      display: flex;
      align-items: center;

      p {
        font-size: rem(32px);
        color: #121212;
      }
    }
  }
}
</style>
